import React from 'react'
import ReactDOM from 'react-dom'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { ToastContainer } from "react-toastify"
import { RedemptionEntry } from './components/RedemptionEntry'

import './index.css'



ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ToastContainer position="top-right" hideProgressBar theme="dark" />
      <Routes>

        <Route path="/" element={<RedemptionEntry />} />

      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
